<template>
  <div v-if="can('update', 'payroll_info')">
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewCommissionRulesGroups" v-if="edited == true" >Descartar cambios</b-button>
    <b-table responsive v-if="commissionRulesGroups.length>0" :fields="commissionRulesGroupFields" :items="commissionRulesGroups" hover striped></b-table>
    <b-button variant="success" v-if="state=='show'" @click="create">Agregar regla de cobro de comisión</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Regla">
        <b-form-select :options="commissionRulesGroupOptions" :value="rule" @input="updateCommissionRulesGroup(['rule', $event])"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Fecha a partir de la cual pertenece a este grupo">
        <b-form-input type="date" @input="updateCommissionRulesGroup(['effective_date', $event])" :value="effective_date"></b-form-input>
      </b-form-group>
      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data (){
    return {
      commissionRulesGroupFields: {
        rule: {
          label: 'Regla',
        },
        effective_date: {
          label: 'A partir del',
        }
      }
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },
    ...mapActions(['resetNewCommissionRulesGroups', 'saveChanges']),
    ...mapMutations({
      updateCommissionRulesGroup: 'updateNewCommissionRulesGroupAttribute',
      create: 'creatingCommissionRulesGroup'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addCommissionRulesGroup', {
          payroll_config_id: this.payrollConfig.id,
          rule: this.rule,
          effective_date: this.effective_date
        });
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.effective_date!='', 'Debe haber una fecha')
      validator.rule(
        this.rule!==null, 'Selecciona un esquema de comisión')
      return validator.validate()
    }
  },
  computed: {
    ...mapGetters({
      edited: 'commissionRulesGroupEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      // commissionRulesGroups: state=>state.employeeManager.employee.commissionRulesGroups,
      state: state=>state.employeeManager.commissionRulesGroupState,
      rule: state=>state.employeeManager.newCommissionRulesGroup.rule,
      effective_date: state=>state.employeeManager.newCommissionRulesGroup.effective_date,
      availableGroups: state=>state.employeeManager.commissionRulesGroups
    }),
    commissionRulesGroupOptions(){
      return this.availableGroups.map(d=>{
        return {
          value: d.id, text: d.name
        }
      }).concat([{value: null, text:'--Seleccionar regla de comisión--'}])
    },
    commissionRulesGroups() { 
      return this.payrollConfig.commissionRulesGroups
    }
  }
  
}
</script>

